import React, { useEffect, useState, useCallback } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import ErrorSoundFile from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import LoginCard from "./LoginCard";
import moment from "moment";
import TopHeader from "./TopHeader";

const backend = await new Backend().init();

export default function LoginLogs() {
  const [playErrorSound] = useSound(ErrorSoundFile);
  const windowSize = useSize();

  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadLogin = useCallback(
    async (start, end) => {
      setLoading(true);
      try {
        const payload = {
          server: localStorage.getItem("server"),
          id: localStorage.getItem("id"),
          username: localStorage.getItem("username"),
          token: localStorage.getItem("token"),
          start: start || moment().startOf("week"),
          end: end || moment().endOf("week"),
        };

        const response = await backend.loginhistory(payload);
        if (response.error === "False") {
          setLoginHistory(response.history || []);
        } else {
          playErrorSound();
          toast.error(response.message || "Failed to load login logs");
        }
      } catch (err) {
        playErrorSound();
        toast.error("Something went wrong while loading logs");
      } finally {
        setLoading(false);
      }
    },
    [playErrorSound]
  );

  useEffect(() => {
    loadLogin();
  }, [loadLogin]);

  return (
    <div className="flex flex-col bg-[var(--background)]">
      {/* Header */}
      <TopHeader onRefresh={loadLogin} />

      {/* Main Content */}
      <div className="flex-1 px-4 pb-4">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <Loading height={windowSize[1] - 90} />
          </div>
        ) : loginHistory.length > 0 ? (
          <div
            style={{
              height: windowSize[1] - 90,
              overflowY: "scroll",
              scrollBehavior: "smooth",
              paddingBottom: 200,
            }}
            className="flex flex-col gap-3"
          >
            {loginHistory.map((item) => (
              <LoginCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 90}
            title="No Login Logs Found"
            subtext="Try selecting a different date range."
            small
          />
        )}
      </div>
    </div>
  );
}
